import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', {
    staticClass: "v-radio",
    style: _vm.styles
  }, [_c('input', _vm._b({
    staticClass: "v-radio__input sr-only",
    attrs: {
      "type": "radio",
      "name": _vm.inputName
    },
    domProps: {
      "checked": _vm.isChecked,
      "value": _vm.value
    },
    on: {
      "change": _vm.handleChange
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), _c('span', {
    staticClass: "v-radio__label"
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-56d2a741_0", {
    source: ".v-radio[data-v-56d2a741]{display:inline-flex;flex-shrink:0;position:relative}.v-radio__label[data-v-56d2a741]{background:#fff;border:.125rem solid var(--c-color);border-radius:50%;cursor:pointer;color:var(--c-color);display:inline-flex;align-items:center;justify-content:center;height:1.25em;font-size:var(--c-size);position:relative;transition:all var(--g-transition-speed);width:1.25em}.v-radio__label[data-v-56d2a741]:after,.v-radio__label[data-v-56d2a741]:before{content:\"\"}.v-radio__label[data-v-56d2a741]:before{background:var(--c-bg-color);border-radius:50%;left:50%;height:275%;position:absolute;opacity:0;top:50%;transform:translate(-50%,-50%);transition:inherit;width:275%}.v-radio__label[data-v-56d2a741]:after{background:var(--c-color);border-radius:inherit;flex-shrink:0;height:.75em;width:.75em;transform:scale(0)}.v-radio__input:focus:not(:disabled)+.v-radio__label[data-v-56d2a741]:before,.v-radio__input:not(:disabled)+.v-radio__label[data-v-56d2a741]:hover:before{opacity:1}.v-radio__input:disabled+.v-radio__label[data-v-56d2a741]{opacity:.75}.v-radio__input:checked+.v-radio__label[data-v-56d2a741]:after{transform:scale(1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-56d2a741";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Radio = __vue_component__;
export { Radio as default };